module.exports = __webpack_public_path__ + "static/media/32.2218ef2c.jpg";